/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSplitVendorLineResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type SplitVendorLineResponse } from '../../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/carts/{cart-id}/{shoppingCartId}/vendor-lines/{vendorCode}/split
 */
export interface SplitRequestBuilder extends BaseRequestBuilder<SplitRequestBuilder> {
    /**
     * Moves the vendor's line and all its items, as they are, into a new cart for the same customer with the shared header copied (bill to, ship to, reps, order note, receipt-to). Returns both carts with their vendor lines and statuses so the client can open the new one. Agency organizations only.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SplitVendorLineResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SplitVendorLineResponse | undefined>;
    /**
     * Moves the vendor's line and all its items, as they are, into a new cart for the same customer with the shared header copied (bill to, ship to, reps, order note, receipt-to). Returns both carts with their vendor lines and statuses so the client can open the new one. Agency organizations only.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SplitRequestBuilderUriTemplate = "{+baseurl}/api/carts/{cart%2Did}/{shoppingCartId}/vendor-lines/{vendorCode}/split";
/**
 * Metadata for all the requests in the request builder.
 */
export const SplitRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: SplitRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSplitVendorLineResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
